// Layout.js
import Header from './Header_White_Base';
import React, {useState, useEffect} from 'react';
import Footer from './Footer';
// import Building from 'D:/SOTEC_Web/src/main/frontend/src/user/BusinessInfo/Component/Building.js' //설계
import '../common/css/Layout.css';




const Layout = ({ children }) => {


  const [showButton, setShowButton] = useState(false);

  
  useEffect(() => {

    
    const handleShowButton = () => {
      if (window.scrollY > 750) {
          setShowButton(true)
      } else {
          setShowButton(false)
      }
  }


  window.addEventListener("scroll", handleShowButton)
  return () => {
      window.removeEventListener("scroll", handleShowButton)
  }

}, [])

const scrollToTop = () => {
  window.scroll({
      top: 0,
      behavior: 'smooth'
  })

}



  return (
    <div className="layout">
        {showButton && (
                             <div className='Upclass' >
                             <div>
                             <div className='arrowUp' style={{color : 'white', fontSize : '25px', width : '50px', height : '27px',  margin : '1px 0 -1px 0'}}  onClick={() => scrollToTop()} >↑</div>
                             <div className='top' onClick={() => scrollToTop()} ></div>
                             <div className='top' onClick={() => scrollToTop()} >TOP</div>
                         </div>
                     </div> 
             
                        )}


      <header>
        <Header/>
      </header>
      
    <div className="content">
        {children}
      </div>
      
      <Footer />
    </div>
  );
};

export default Layout;